import React from 'react'
import CheckIn from '../../modules/CheckIn'

const Index = () => {
  return <CheckIn />
}
export default Index
